
export const templateForms = () => {
    // Filters down the forms that belong to the template
    return function(input, template_id, active) {
        if(!Array.isArray(input)) {
            return [];
        };
        return input.filter(function (el) { return el.template_id === template_id && el.id && el.active === active});
    }
};